var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10348_42586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.07031,
    y: 4.90625,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.57031,
    y: 5.40625,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7461 31.8834L28.6621 36.2875C27.8977 36.6181 27.0195 36.7083 26.19 36.513L20.3673 35.1601V29.9746C22.4004 29.2832 24.6774 29.5086 26.499 30.5758C26.7104 30.6961 26.9544 30.7862 27.2146 30.8313L31.1669 31.4776C31.541 31.5378 31.7524 31.8083 31.6548 32.2893C31.5898 32.5899 31.3457 33.0108 30.6139 33.0108H25.6207C25.393 33.0108 25.1816 33.1611 25.1328 33.3715C25.084 33.6571 25.3117 33.8976 25.6044 33.8976H30.6139C31.7036 33.8976 32.6144 33.116 32.6632 32.1089C32.6795 31.8684 32.6306 31.628 32.5494 31.4175L38.2582 30.5006C38.307 30.4856 38.3558 30.4856 38.3883 30.4856C38.7461 30.4856 39.0714 30.711 39.1528 31.0417C39.2665 31.3724 39.0877 31.7331 38.7461 31.8834ZM18.9523 29.1328H15.7157C15.3742 29.1328 15.0977 29.3883 15.0977 29.704V35.2955C15.0977 35.611 15.3742 35.8666 15.7157 35.8666H18.9523C19.2938 35.8666 19.5703 35.611 19.5703 35.2955V29.704C19.5703 29.3883 19.2938 29.1328 18.9523 29.1328Z",
    fill: "#06513D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.275 21.5068C26.985 21.5068 25.1367 23.2092 25.1367 25.3182C25.1367 27.4273 26.985 29.1297 29.275 29.1297C31.565 29.1297 33.4133 27.4273 33.4133 25.3182C33.4133 23.2092 31.565 21.5068 29.275 21.5068ZM29.6512 27.5328V27.9245C29.6512 28.1052 29.4877 28.2709 29.275 28.2709C29.0787 28.2709 28.8988 28.1203 28.8988 27.9245V27.6081C28.6207 27.6081 28.3427 27.5629 28.0973 27.4876V26.7343C28.3427 26.8398 28.6862 26.9302 28.9969 26.9302C29.5367 26.9302 29.8639 26.7042 29.8639 26.3276C29.8639 25.9811 29.6512 25.7853 29.0296 25.5744C28.1955 25.3032 27.7701 24.8663 27.7701 24.3089C27.7701 23.6912 28.2281 23.2092 28.9152 23.0586V22.6819C28.9152 22.5011 29.0787 22.3354 29.2913 22.3354C29.4877 22.3354 29.6676 22.486 29.6676 22.6819V22.9983C29.8966 23.0133 30.1256 23.0586 30.3218 23.1338V23.8871C30.1583 23.7967 29.8475 23.6762 29.4386 23.6762C28.9969 23.6762 28.7026 23.9021 28.7026 24.2185C28.7026 24.5499 28.9643 24.7006 29.5694 24.9115C30.4527 25.2278 30.8289 25.6196 30.8289 26.2523C30.7962 26.9151 30.3546 27.367 29.6512 27.5328ZM36.1776 20.844C36.1776 22.1998 35.1962 23.3296 33.8549 23.6762C33.7078 23.3296 33.5115 22.9983 33.2662 22.6819V22.5463C33.8222 22.4107 34.1494 22.0643 34.1494 21.5671C34.1494 21.085 33.8549 20.7686 33.1843 20.5276C32.7264 20.3619 32.5137 20.2565 32.5137 20.0004C32.5137 19.7443 32.7427 19.5786 33.0862 19.5786C33.397 19.5786 33.6423 19.684 33.7732 19.7443V19.1718C33.626 19.1116 33.4461 19.0814 33.2662 19.0664V18.8103C33.2662 18.6595 33.1352 18.5541 32.9881 18.5541C32.8244 18.5541 32.71 18.6746 32.71 18.8103V19.0965C32.1702 19.217 31.8267 19.5786 31.8267 20.0606C31.8267 20.4825 32.1702 20.8289 32.8081 21.0398C33.2825 21.2056 33.4624 21.3562 33.4624 21.6274C33.4624 21.9136 33.2171 22.0944 32.7917 22.0944C32.7754 22.0944 32.7591 22.0944 32.7264 22.0944C31.9576 21.4014 30.9271 20.9344 29.7984 20.8289C29.8148 19.217 31.2379 17.9064 32.9881 17.9064C34.7383 17.8913 36.1776 19.217 36.1776 20.844Z",
    fill: "#06513D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10348_42586",
    x: 0.870313,
    y: 0.70625,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10348_42586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10348_42586",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct33);
export default __webpack_public_path__ + "static/media/product33.b34a2aea21f6a8ecb0c4d14fce5f9802.svg";
export { ForwardRef as ReactComponent };